import { ChangeEvent, FC } from 'react';

import { Box, Label, Radio, RadioGroup, RadioGroupDirection } from '@base-app';
import { DevToolsContainer } from '@common/components/dev-tools';
import { PartnerOrganization } from '@modules/core/types/partnerType.type';
import { buildSwitchPartnerLayouts } from '@/modules/core/utils/partnerType';
import { getDisplayNameByPartnerOrganization } from '@/modules/core/utils';
import { PartnerSwitcherProps } from './PartnerSwitcher.types';

const partners = Object.values(PartnerOrganization);

const PartnerSwitcher: FC<PartnerSwitcherProps> = ({ handlerOnChange, defaultValue }) => {
  const handleChangePartner = (event: ChangeEvent<HTMLInputElement>): void => {
    const { value } = event.target;
    value && handlerOnChange(value as unknown as PartnerOrganization);
  };

  const layouts = buildSwitchPartnerLayouts();

  const getDisplayName = (partner: PartnerOrganization): string => {
    return `${getDisplayNameByPartnerOrganization(partner)} (${
      layouts?.[partner as unknown as string] ?? 'No Layout'
    })`;
  };

  return (
    <DevToolsContainer>
      <Label css={{ whiteSpace: 'nowrap' }}>{`Partner Switch`}</Label>
      <RadioGroup
        defaultValue={(defaultValue as unknown as string) ?? undefined}
        direction={RadioGroupDirection.COLUMN}
        id=""
        name=""
        onChange={handleChangePartner}
      >
        {partners.map((partner, index) => (
          <Radio id={partner} key={index} value={partner} name={partner}>
            <Box css={{ whiteSpace: 'nowrap' }} title={getDisplayName(partner as PartnerOrganization)}>
              {getDisplayName(partner as PartnerOrganization)}
            </Box>
          </Radio>
        ))}
      </RadioGroup>
    </DevToolsContainer>
  );
};

export default PartnerSwitcher;
